<template>
  <div>
    <a-spin id="root_block" :spinning="spinningMain" size="large">
      <div id="app">
        <div id="maindivmenu">
          <div
            v-if="status_license_main.condition != 'empty'"
            @click="changeTab(true)"
            :class="{ Active: visible_app }"
            class="alltabs"
          >
            <div id="OpenApp">
              <i class="fa fa-th"></i>
              <span>&nbsp;{{ $t("AppTab") }}</span>
            </div>
          </div>
          <div
            v-if="isAdmin == true"
            @click="changeTab(false)"
            :class="{ Active: !visible_app }"
            class="alltabs"
          >
            <div id="OpenSettings">
              <i class="fa fa-cog"></i>
              <span>&nbsp;{{ $t("Settings") }}</span>
            </div>
          </div>
          <div id="labelinfo">
            <div>
              <img src="./assets/light.png" />
            </div>
            <span>
              <a
                target="_blank"
                href="https://bitrix24public.com/cloud.bitrix24.pl/form/85_bank_idey/rqpzor/"
                >{{ $t("Have an idea to make the app better") }}</a
              >
            </span>
          </div>
        </div>
        <a-spin
          :spinning="spinning"
          size="large"
          style="background-color: white"
        >
          <div id="blockApp" class="mainpage">
            <settingsApp
              v-if="!visible_app && info != null"
              :settings="info"
              :user_val="user_setup != null ? user_setup : {}"
              @updateFiles="updateFiles"
              @changeSpinning="changeSpinning"
              @loadFilesAndSettings="loadFilesAndSettings"
              @changeTab="changeTab"
            />
            <docTable
              v-else-if="
                visible_app && status_license_main.condition != 'empty'
              "
              :InitInfo="info"
              :fileList="files != null ? files : []"
              :key_words="user_setup != null ? user_setup.words : []"
              :responsible="user_setup != null ? user_setup.responsible : ''"
              :specialization="
                user_setup != null ? user_setup.SPECJALIZACJA : []
              "
              :user_setup="user_setup"
              @updateFiles="updateFiles"
              @changeSpinning="changeSpinning"
              @refresh="loadFilesAndSettings"
              @filterDocList="filterDocList"
            />
          </div>
        </a-spin>
        <div id="footer">
          <div id="footerone">
            <div>
              <i class="fa fa-shopping-cart"></i>
              &nbsp;
              <a
                href="https://my.support.pl/cart.php?gid=4&subg=all"
                target="_blank"
              >
                <label>{{ $t("Application Catalog") }}</label>
              </a>
            </div>
            <div>
              <i class="fa fa-folder"></i>
              &nbsp;
              <a
                href="https://my.support.pl/index.php?rp=/knowledgebase/5/Produkty-i-Usugi"
                target="_blank"
              >
                <label>{{ $t("Knowledge Base") }}</label>
              </a>
            </div>
            <div>
              <i class="fa fa-comments"></i>
              &nbsp;
              <a
                href="https://cloud.bitrix24.pl/online/apps-help"
                target="_blank"
              >
                <label>{{ $t("Online-chat") }}</label>
              </a>
            </div>
            <div>
              <i class="fa fa-code"></i>
              &nbsp;
              <a
                href="https://bitrix24public.com/cloud.bitrix24.pl/form/83_ostavit_otzyv_o_prilozhenii/4uha5i/"
                target="_blank"
              >
                <label>{{ $t("Order an app development") }}</label>
              </a>
            </div>
          </div>
          <div class="anyfooter">
            <span>{{
              $t("Need more functionality on these app? Write us!")
            }}</span>
            <a href="mailto:bitrix24@support.pl">&nbsp;bitrix24@support.pl</a>
          </div>
          <div class="anyfooter">
            <span>{{ $t("Developed by") }}</span>
            <a href="https://support.pl" target="_blank">&nbsp;SUPPORT.PL</a>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import docTable from "./components/docTable.vue";
import settingsApp from "./components/settingsApp.vue";
import { getSettings } from "./requestFunc";
import moment from "moment";

export default {
  name: "App",
  components: {
    docTable,
    settingsApp,
  },
  data: function () {
    return {
      spinning: false,
      isAdmin: null,
      spinningMain: false,
      info: {},
      user_setup: null,
      visible_app: true,
      files: null,
      status_license_main: { condition: "empty" },
    };
  },
  methods: {
    moment,
    filterDocList(fileID) {
      this.files = this.files.filter((el) => {
        if (el.ID != fileID) {
          return el;
        }
      });
    },
    updateFiles(data) {
      this.files = data.files.length != 0 ? data.files : [];
      if (data.settings != undefined) {
        this.user_setup = Object.assign(this.user_setup, data.settings);
        this.changeTab(true);
      }
    },
    changeSpinning() {
      this.spinning = !this.spinning;
    },
    changeTab(flag) {
      if (this.isAdmin == true) {
        this.visible_app = flag;
      }
    },
    resize() {
      // eslint-disable-next-line
      BX24.resizeWindow(
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "width"
          )
        ),
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "height"
          )
        )
      );
    },

    async loadFilesAndSettings() {
      let vm = this;
      vm.spinningMain = true;
      let resp_getSettings = await getSettings();
      if (resp_getSettings.ok) {
        let vals = await resp_getSettings.json();
        vals.option_get.responsible = JSON.parse(vals.option_get.responsible);
        var fields = [];
        for (let i in vals.userfields) {
          if (vals.userfields[i]["listLabel"] != undefined) {
            fields.push(vals.userfields[i]);
          }
        }

        let status_license = {};
        if (vals.license.lic_key == "") {
          if (moment().isBefore(moment(vals.license.trial_end_date))) {
            status_license.condition = "trial";
          } else status_license.condition = "empty";
        } else {
          status_license.condition = "full";
        }
        this.status_license_main = status_license;

        console.log(status_license);
        if (this.status_license_main.condition == "empty") {
          // this.visible_app = false;
          this.changeTab(false);
        }

        vm.info = {
          crm_status_list: vals.crm_status_list,
          data_getchildren: vals.data_getchildren,
          data_user: vals.data_user,
          company: vals.company,
          userfields: fields,
          my_company: vals.my_company,
          user_folder: vals.option_get.folder,
          nip: vals.option_get.nip,
          teczkalist: vals.option_get.teczkalist,
          nip_field: vals.option_get.nip_field,
          matrix: vals.right,
          license: vals.license,
          status_license: status_license,
          table_size: vals.option_get.table_size,
          fields_table: vals.option_get.fields_table,
        };
        vm.files = vals.data_file;
        if (!vals.option_get.words) vals.option_get.words = [];
        vm.user_setup = vals.option_get;
        vm.$message.info(vm.$t("Download complete!"));
      } else {
        alert(vm.$t("http_error") + resp_getSettings.status);
        vm.$message.error(vm.$t("Error loading files"));
      }
      vm.spinningMain = false;
    },
  },
  async created() {
    let vm = this;
    // eslint-disable-next-line
    let lang = BX24.getLang();
    if (lang == 'br' || lang == 'tr' || lang == 'ja' || lang == 'ms' || lang == 'fr' || lang == 'sc' || lang == 'vn' || lang == 'th' || lang == 'la' || lang == 'it' || lang == 'ua' || lang == 'tc' || lang == 'id' || lang == 'hi') {
      lang = 'en'
    }
    console.log(lang, 'lang')
    vm.$i18n.locale = lang;
  },
  async mounted() {
  //  console.log("ALOOOE");
    let vm = this;
    // eslint-disable-next-line
    // BX24.init(() => {
    // eslint-disable-next-line
    // vm.$i18n.locale = BX24.getLang();
    // });

    vm.loadFilesAndSettings();
    // eslint-disable-next-line
    vm.isAdmin = BX24.isAdmin();
    // eslint-disable-next-line
    BX24.fitWindow();
  },
  updated() {
    this.resize();
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  white-space: nowrap;
}
</style>
